import { typeCheckAppModule } from "src/utils";
import { NAME } from "./constants";
import { Tiers } from "./Tiers";

export const tiers = typeCheckAppModule({
    NAME,
    Container: Tiers,
});
